import LocationHead from '../shared/LocationHead';
import getLayoutProps from '../shared/getLayoutProps';
import MetaHead from '../shared/MetaHead';
import BodyContent from '../components/BodyContent';
import StaticPage from '../components/StaticPage';
import { getTermsOfUse } from '../server/cms';

export default function TermsOfUse(props) {
  return (
    <>
      <MetaHead { ...props } />
      <LocationHead
        title="Terms of Use"
        pathname="/terms-of-use"
      />
      <StaticPage>
        <BodyContent>
          { props.content }
        </BodyContent>
      </StaticPage>
    </>
  );
};

export const getStaticProps = async function() {
  const { props, revalidate } = await getLayoutProps();
  const termsOfUse = await getTermsOfUse();
  return {
    revalidate,
    props: {
      ...props,
      ...termsOfUse,
    },
  };
};